export default __webpack_public_path__ + "static/media/botanyLabImage.0424bb8a.png";